import { Icon, IconProps } from './Icon';

export type DropDownProps = IconProps;

export const DropDown = (props: DropDownProps) => (
  <Icon width="16px" height="16px" fill="none" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" {...props}>
    <path d="m8 11 4.33-4.5H3.67L8 11Z" fill="currentcolor"/>
  </Icon>
)
